<div class="widget-container">
	<div class="filter-container">

		<div class="row" *ngIf="!hideFilters">
			<!-- period filter -->
			<div class="col-sm-6 col-md-3 col-lg-3">
				<label for="periodSelect">{{"rt_history.periods" | translate}}</label>
				<ng-select
					class="select"
					[items]="periods"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'period', value: $event.value})"
					[placeholder]="'g.durations' | translate"
					[(ngModel)]="selectedPeriod"
				></ng-select>
			</div>

			<!-- truck type filter -->
			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="hasTruckTypeFilter">
				<label for="truckTypeSelect">{{"exception_reports.truck_types" | translate}}</label>
				<ng-select
					class="select"
					[items]="truckTypes"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'truckType', value: $event.value})"
					[placeholder]="'g.type' | translate"
					[(ngModel)]="selectedTruckType"
				></ng-select>
			</div>

			<!-- days filter -->
			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="hasWorkingDaysFilter">
				<label for="workingDaysSelect">{{"operation_analysis.working_days" | translate}}</label>
				<ng-select
					class="select"
					[items]="daysFilters"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'daysFilter', value: $event.value})"
					[placeholder]="'g.durations' | translate"
					[(ngModel)]="selectedDaysFilter"
				></ng-select>
			</div>

			<!-- voltage filter -->
			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="hasVoltageFilter">
				<label for="batteryVoltageSelect">{{"fleet_reports.battery_voltage" | translate}}</label>
				<ng-select
					id="batteryVoltageSelect"
					class="select"
					[items]="batteryVoltagesOptions"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'voltageFilter', value: $event.value})"
					[placeholder]="'qv.voltage' | translate"
					[(ngModel)]="selectedBatteryVoltage"
				></ng-select>
			</div>

			<!-- capacity filter -->
			<div class="col-sm-6 col-md-3 col-lg-3" *ngIf="hasCapacityFilter">
				<label for="batteryCapacitySelect">{{"devices.battery_capacity" | translate}}</label>
				<ng-select
					id="batteryCapacitySelect"
					class="select"
					[items]="batteryCapacitiesOptions"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					(change)="onSelectionChanged({filter: 'capacityFilter', value: $event.value})"
					[placeholder]="'qv.capacity' | translate"
					[(ngModel)]="selectedBatteryCapacity"
				></ng-select>
			</div>
		</div>
	</div>

	<div class="widget-bar" [style.--width]="chartWidthPx + 'px'">
		<span *ngFor="let range of ranges" [style.--width]="range.width + 'px'" [style.--color]="range.color"></span>
		<div class="value-indecator" [style.--left]="valuePx + 'px'"></div>
	</div>

	<div class="slider-container" [style.--width]="chartWidthPx + 'px'">
		<input type="range" min="0" max="100" value="null" class="slider" id="slider">
		<div class="labels">
				<span class="right">{{rangesLabels[0]}}</span>
				<span class="right">{{rangesLabels[1]}}</span>
				<span class="right">{{rangesLabels[2]}}</span>
				<span class="left">{{rangesLabels[3]}}</span>
				<span class="left">{{rangesLabels[4]}}</span>
				<span class="left">{{rangesLabels[5]}}</span>
		</div>
	</div>

	<div class="detials" [style.--width]="chartWidthPx + 'px'">
		<span [style.--color]="statusColor" [style.--text-color]="textColor">{{value}}%</span>
		<span [style.--color]="statusColor" [style.--text-color]="textColor">{{valueStatus}}</span>
	</div>
</div>
